import styled, { css } from "styled-components";

export const Truncate = styled.p<{
  $paddingLeft?: number;
}>`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: unset;

  ${(props) =>
    props.$paddingLeft &&
    css`
      padding-left: ${props.$paddingLeft}rem;
    `}
`;

export const Blur = styled.span`
  filter: blur(3px);
  user-select: none;
  color: unset;
`;
